import CloseIcon from "@mui/icons-material/Close"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"

import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"

import CustomTextField from "../CustomTextField"

import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { tipoDeLicencias } from "../../Redux/licencias"
import TokenContext from "../../context/TokenContext"

import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { DialogTitle, IconButton } from "@mui/material"
import { MuiFileInput } from "mui-file-input"
import { toast } from "react-toastify"
import { UserAuth } from "../../context/AuthContext"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomDateField from "../CustomDateField"

const validacionSchema = yup.object().shape({
  tipoLicencia: yup.object({ value: yup.string().required("El tipo de licencia es requerido") }),
  cantidadDias: yup.string().required("Por favor indica la cantidad de dias."),
  fechaDesde: yup.string().required("Required"),
})

const ModalSolicitudLicencia = ({ open, handleClose, onSubmit }) => {
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const { empleado } = UserAuth()

  const [fullWidth, setFullWidth] = React.useState(true)
  const [maxWidth, setMaxWidth] = React.useState("sm")

  const [selectedFiles, setSelectedFiles] = React.useState([])
  const [tipoLicencias, setTipoLicencias] = React.useState([])
  const tipoLicenciasSelector = useSelector((store) => store.licencias.tipoLicencia)
  const loadCargaLicencia = useSelector((store) => store.licencias.loadCargaLicencia)

  React.useEffect(() => {
    if (token) {
      dispatch(tipoDeLicencias(token))
    }
  }, [token])

  React.useEffect(() => {
    if (tipoLicenciasSelector.length > 0) {
      var array = []
      tipoLicenciasSelector.forEach((tipo) => {
        var objeto = {
          label: tipo.new_name,
          value: tipo.new_tipodelicenciaid,
        }
        array.push(objeto)
      })
      setTipoLicencias(array)
    }
  }, [tipoLicenciasSelector])

  const defaultValues = {
    empleado: empleado.empleadoid,
    tipoLicencia: null,
    cantidadDias: null,
    fechaDesde: null,
    comentarios: "",
  }

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, trigger, setValue } = methods

  const submitDatos = (datos) => {

    const formData = new FormData()
    for (let index = 0; index < selectedFiles.length; index++) {
      if (selectedFiles[index].size >= 15000000) {
        toast.error("El archivo no puede superar los 15 megas", {
          theme: "dark",
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        setSelectedFiles([])
        return
      }
      let element = selectedFiles[index]
      formData.append(`body${index}`, element)
    }
    onSubmit(datos, selectedFiles, formData)
  }

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile)
  }

  return (
    <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={open} onClose={handleClose}>
      <DialogTitle sx={{ m: 1, p: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} md={12} sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={tipoLicencias}
                req="true"
                type="text"
                name="tipoLicencia"
                lab="Tipo de licencia"
                helperText="El tipo de licencia es requerido"
              />
            </Grid>

            <Grid item xs={12} md={6} sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="cantidadDias"
                label="Dias Solicitados"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica la cantidad de dias."
                type="number"
                className="custom-helper"
              />
            </Grid>

            <Grid xs={12} md={6} item sx={{ pt: 0, pb: 0 }}>
              <CustomDateField
                name="fechaDesde"
                label="Fecha desde:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha desde"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Comentarios"
                name="comentarios"
                multiline={true}
                rows="4"
              />
            </Grid>
            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <MuiFileInput value={selectedFiles} multiple label="Adjuntar Certificado" onChange={changeHandler} fullWidth />
            </Grid>
            <Grid sx={{ px: 2, mb: 2, mt: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box sx={{ height: "100%" }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                </Box>
                <Box sx={{ height: "100%" }}>
                  <Typography>El tamaño máximo permitido por archivo es de 15 MB</Typography>
                </Box>
              </Box>
            </Grid>

            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={loadCargaLicencia === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </Grid>
        </FormProvider>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSolicitudLicencia
